import { render, staticRenderFns } from "./positioning-device-infos.vue?vue&type=template&id=6622dc84&scoped=true"
import script from "./positioning-device-infos.vue?vue&type=script&lang=js"
export * from "./positioning-device-infos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6622dc84",
  null
  
)

export default component.exports